var map = {
	"./altria-group-inc.png": 1758,
	"./archer-daniels-midland-co.png": 1759,
	"./british-american-tobacco-plc.png": 1760,
	"./chevron-corp.png": 1761,
	"./corecivic-inc.png": 1762,
	"./duke-energy-corp.png": 1763,
	"./exxon-mobil-corp.png": 1764,
	"./geogroup.png": 1765,
	"./jbs-sa.png": 1766,
	"./lockheed-martin-corp.png": 1767,
	"./northrop-grumman-corp.png": 1768,
	"./philip-morris-international-inc.png": 1769,
	"./raytheon-technologies-corp.png": 1770,
	"./smith--wesson-brands-inc.png": 1771,
	"./sturm-ruger--co-inc.png": 1772,
	"./tyson-foods-inc.png": 1773,
	"./vista-outdoor-inc.png": 1774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1757;